module.exports = __webpack_public_path__ + "static/media/content_es.bddca3f1.yaml";


//////////////////
// WEBPACK FOOTER
// ./src/translations/locales/content_es.yaml
// module id = 734
// module chunks = 0